import React, { useState, useEffect } from 'react'
import Card from './Card';
import RadioSort from './RadioSort';
import FilterSort from './FilterSort';
import TagSort from './TagSort';
import Pagination from './Pagination';
import Popup from './Popup';

const pageSize = 18;

export default function SortList({ list }) 
{  
  const [formatFilter, setFormatFilter] = useState(-1);
  const [systemFilter, setSystemFilter] = useState(-1);
  const [gmFilter, setGMFilter] = useState(-1);
  const [authorFilter, setAuthorFilter] = useState(-1);
  const [tagFilter, setTagFilter] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = useState(Math.ceil(list.nodes.length / pageSize));
  const [hiding, setHiding] = useState(true);
  const [shownList, setShownlist] = useState(list.nodes);

  const [openPopup, setOpenPopup] = useState(false);
  const [currentItem, setCurrentItem] = useState({});

  const [popupHeight, setPopupHeight] = useState(0);


  useEffect(() => {
    let newList = [];

    list.nodes.forEach((item) => {
      if(
        (formatFilter === -1 || list.formatList[formatFilter] === item.replaySessionFormat) &&
        (systemFilter === -1 || list.systemList[systemFilter] === item.replaySystemName) &&
        (gmFilter === -1 || list.gmList[gmFilter] === item.replayGm) &&
        (authorFilter === -1 || list.scenarioAuthorList[authorFilter] === item.replayScenarioAuthor)
      )
      {
        if(tagFilter.length === 0)
          newList.push(item);
        else
        {
          for(let i=0;i<tagFilter.length;i++)
          {
            if(item.replayHashTag.indexOf(tagFilter[i]) > -1)
            {
              newList.push(item);
              break;
            }
          }
        }
      }
        
    });

    setHiding(true);
    setTimeout(() => {
      setShownlist(newList.slice(currentPage*pageSize,(currentPage+1)*pageSize));
      setTotalPage(Math.ceil(newList.length / pageSize));
      setTimeout(() => {
        setHiding(false);
      },50);
    },400);

  },[
    formatFilter,systemFilter,gmFilter,authorFilter,tagFilter,currentPage,list
  ])
  
  const updateFilter = (type,val) => {
    setCurrentPage(0);
    switch(type)
    {
      case 'format' : setFormatFilter(val);break;
      case 'system' : setSystemFilter(val);break;
      case 'gm' : setGMFilter(val);break;
      case 'format-label' : 
        setFormatFilter(list.formatList.indexOf(val));
        setSystemFilter(-1);
        setGMFilter(-1);
        setAuthorFilter(-1);
        setTagFilter([]);
        break;
      case 'system-label' : 
        setFormatFilter(-1);
        setSystemFilter(list.systemList.indexOf(val));
        setGMFilter(-1);
        setAuthorFilter(-1);
        setTagFilter([]);
        break;
      case 'gm-label' : 
        setFormatFilter(-1);
        setSystemFilter(-1);
        setGMFilter(list.gmList.indexOf(val));
        setAuthorFilter(-1);
        setTagFilter([]);
        break;
      case 'author' : setAuthorFilter(val);break;
      case 'tag' : setTagFilter(val);break;
    }
  }

  useEffect(() =>{
    setTimeout(() => {
      if(typeof document != 'undefined' && document.querySelector('.popupContainer') != null)
        setPopupHeight(document.querySelector('.popupContainer').offsetTop + document.querySelector('.popupItem').clientHeight + 50)
    },300);
    
  },[openPopup])


  return(
  <div className="appsContainer"
    style={{minHeight: !openPopup ? '0px' : `${popupHeight}px`}}
  >
    <div className="filters container">
      <RadioSort label={'以跑團方式篩選：'} 
        list={list.formatList} 
        value={formatFilter}
        onChange={(e) => {
          updateFilter('format',e);
        }} 
        allLabel={'顯示全部'} 
        filterId={`format`} />
      <div className="row">
        <FilterSort 
          label={'以TRPG系統篩選'} 
          list={list.systemList} 
          value={systemFilter}
          onChange={(e) => {
            updateFilter('system',e);
          }} 
          allLabel={'顯示全部系統的團錄'} 
          filterId={`system`} />
        <FilterSort 
          label={'以帶團GM篩選'} 
          list={list.gmList} 
          value={gmFilter} 
          onChange={(e) => {
            updateFilter('gm',e);
          }} 
          allLabel={'顯示全部GM的團錄'} 
          filterId={`gm`} />
        <FilterSort 
          label={'以劇本作者篩選'} 
          value={authorFilter} 
          list={list.scenarioAuthorList} 
          onChange={(e) => {
            updateFilter('author',e);
          }} 
          allLabel={'顯示全部劇本作者'} 
          filterId={`author`} />
      </div>
      <div className="row">
        <TagSort 
          label={'以風格篩選'} 
          value={tagFilter} 
          list={list.tagList} 
          onChange={(e) => {
            updateFilter('tag',e);
          }} 
          filterId={`tag`} />
      </div>
    </div>
    <div className="list container">
      {shownList.length > 0 ?
        <div className="row" id="listRow">
          {shownList.map((item,index) => <Card data={item} hiding={hiding} key={`card_${index}`} updateFilter={updateFilter} onClick={(e) => {
            setOpenPopup(true);
            setCurrentItem(e);
          }}/>)}
        </div>
      :
        <div className="noRecord col-xs-12">
          沒有找到資料。
        </div>
      }
    </div>
    <Pagination current={currentPage} total={totalPage} onChangePage={setCurrentPage} />
    {openPopup &&
      <Popup opened={openPopup} onOpen={() => {}} onClose={() => {
        setTimeout(() => {
          setOpenPopup(false);
        },300);
      }} item={currentItem} updateFilter={updateFilter} />
    }
    <div className="footer">
      本網站僅在GM主動提供資料的情況下作綜合及整理用途，所有文字、圖片及團錄版權均為GM或其玩家所有，未經所有版權持有人同意請勿轉載。
    </div>
  </div>)
}